import {ExperimentsBag} from '@wix/wix-experiments'

const defaultState = {} as ExperimentsBag

export const experiments = (state = defaultState) => state
